import { http } from '../../jobs/api/http';

export async function fetchPhantoms() {
  const res = await http.get('/api/redis/phantoms');
  return res.data.phantoms || [];
}

export async function createPhantom(data) {
  const res = await http.post('/api/redis/phantoms', data);
  return res.data;
}

export async function deletePhantom(phantomId) {
  const res = await http.delete(`/api/redis/phantoms/${phantomId}`);
  return res.data;
}

export async function updatePhantom(phantomId, updates) {
  const res = await http.patch(`/api/redis/phantoms/${phantomId}`, updates);
  return res.data;
}

export async function fetchCompatiblePhantoms(params) {
  const res = await http.get('/api/redis/phantoms/compatible', { params });
  return res.data.phantoms || [];
}
